import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M72.991 41.1899C72.991 41.1899 59.431 34.2999 55.381 29.5699C50.881 24.3099 51.081 1.66992 51.081 1.66992H38.661C38.661 1.66992 38.971 24.4199 34.361 29.5699C29.471 35.0299 16.751 40.9899 16.751 40.9899C22.941 55.5699 35.341 59.2899 44.871 59.2899C54.411 59.2799 66.801 55.7699 72.991 41.1899Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.5208 58.0899C84.9008 46.0899 81.3108 42.8399 76.6408 40.4899C74.1308 39.2199 59.5508 31.6499 59.5508 31.6499L54.2008 25.6299L44.8708 38.4999L35.5408 25.6299L30.1908 31.6499C30.1908 31.6499 15.6108 39.2199 13.1008 40.4899C8.4308 42.8399 4.99079 46.4899 3.22079 58.0899C1.40079 70.0299 1.30078 71.8599 1.30078 71.8599H88.4508C88.4408 71.8499 88.1508 70.1399 86.5208 58.0899Z"
        fill="#B7C33E"
        stroke="#7D990A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M44.8806 44.7098C45.6096 44.7098 46.2005 44.1188 46.2005 43.3898C46.2005 42.6608 45.6096 42.0698 44.8806 42.0698C44.1515 42.0698 43.5605 42.6608 43.5605 43.3898C43.5605 44.1188 44.1515 44.7098 44.8806 44.7098Z"
        fill="white"
      />
      <path
        d="M44.8806 53.85C45.6096 53.85 46.2005 53.259 46.2005 52.53C46.2005 51.8009 45.6096 51.21 44.8806 51.21C44.1515 51.21 43.5605 51.8009 43.5605 52.53C43.5605 53.259 44.1515 53.85 44.8806 53.85Z"
        fill="white"
      />
      <path d="M18.0606 38.7L23.2406 47.8999L18.3406 51.92L12.3906 41.41L18.0606 38.7Z" fill="#7D990A" />
      <path d="M31.3911 32.1199L35.1211 40.7999L28.5211 44.3799L23.8311 36.0399L31.3911 32.1199Z" fill="#3C630A" />
      <path d="M23.8502 36.0398L28.6602 44.5198L22.9402 47.6098L18.2002 38.9698L23.8502 36.0398Z" fill="#179917" />
      <path d="M71.7309 38.7L66.6309 47.83L71.7309 51.65L77.4008 41.41L71.7309 38.7Z" fill="#7D990A" />
      <path d="M58.511 32.2L55.001 40.64L61.301 44.2899L65.961 36.06L58.511 32.2Z" fill="#3C630A" />
      <path d="M65.941 36.0398L61.041 44.7098L66.631 47.8298L71.601 39.0098L65.941 36.0398Z" fill="#179917" />
      <path
        d="M47.3002 61.2998V44.1698L52.8102 38.5698C52.8102 38.5698 71.1003 50.1898 72.2903 51.4998C73.4903 52.8198 74.6402 70.7398 74.6402 70.7398H14.9902C14.9902 70.7398 16.1502 52.8098 17.3402 51.4998C18.5402 50.1798 36.8203 38.5698 36.8203 38.5698L42.9602 45.6398L42.3302 51.3298V61.2998H47.3002Z"
        fill="white"
      />
      <path
        d="M38.1006 39.9898L42.5906 46.4398C42.5906 46.4398 43.7406 42.0998 44.8106 40.2498L41.0106 34.7998L38.1006 39.9898Z"
        fill="#3C630A"
      />
      <path
        d="M51.7003 39.9899L48.6804 35.3799L45.7204 39.4099C45.7204 39.4099 42.3604 44.1999 42.3604 50.1099C42.3604 56.0199 42.3604 61.2899 42.3604 61.2899H47.2904C47.2904 61.2899 47.2904 54.8399 47.2904 50.2199C47.3004 45.6099 51.7003 39.9899 51.7003 39.9899Z"
        fill="#3C630A"
      />
      <path
        d="M44.9205 58.7099C45.4176 58.7099 45.8205 58.307 45.8205 57.8099C45.8205 57.3129 45.4176 56.9099 44.9205 56.9099C44.4234 56.9099 44.0205 57.3129 44.0205 57.8099C44.0205 58.307 44.4234 58.7099 44.9205 58.7099Z"
        fill="#7D990A"
      />
      <path
        d="M44.9205 51.28C45.4176 51.28 45.8205 50.877 45.8205 50.38C45.8205 49.8829 45.4176 49.48 44.9205 49.48C44.4234 49.48 44.0205 49.8829 44.0205 50.38C44.0205 50.877 44.4234 51.28 44.9205 51.28Z"
        fill="#7D990A"
      />
      <path
        d="M49.2704 35.3699C48.3504 36.4399 47.5004 37.6599 46.7504 38.8999C45.9904 40.1399 45.3304 41.4399 44.7204 42.7599C44.1204 44.0799 43.6004 45.4299 43.1804 46.8299C42.7704 48.2299 42.5304 49.6699 42.3804 51.1699C42.1004 49.6999 42.0704 48.1499 42.2704 46.6399C42.5104 45.1399 42.8804 43.6399 43.4504 42.2199C44.0204 40.8099 44.7204 39.4499 45.5004 38.1499C46.3004 36.8499 47.1104 35.5999 48.0704 34.3599L49.2704 35.3699Z"
        fill="#7D990A"
      />
      <path
        d="M30.1904 31.6499L36.9104 44.5599L41.8404 34.3099L35.5404 25.6299L30.1904 31.6499Z"
        fill="#3C630A"
        stroke="#7D990A"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M59.5511 31.6499L52.8311 44.5599L47.8711 34.3099L54.2011 25.6299L59.5511 31.6499Z"
        fill="#3C630A"
        stroke="#7D990A"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="44.8687"
          y1="40.5989"
          x2="44.8687"
          y2="7.57162"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
